import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
  getTaskById: async ({ id }) =>
    apiCall(`${config.baseAPIUrl}/task/get/${id}`, {
      method: 'POST',
    }),
}
